module.exports = __webpack_public_path__ + "static/media/basketball.247482ba.jpg";